import {
    InputBaseComponentProps
} from '@mui/material';
import React from 'react';
import { NumericFormat, NumericFormatProps } from 'react-number-format';

export interface NumberFormatCustomProps extends InputBaseComponentProps {
    allowOnlyIntegers?: boolean;
    minValue?: number;
    maxValue?: number;
    decimalScale?: number;
    allowNegative?: boolean;
    maxLength?: number;
}

export const NumberFormatCustom = React.forwardRef<
    HTMLInputElement,
    NumericFormatProps & NumberFormatCustomProps
>(function NumberFormatCustom(props, ref) {
    const {
        onChange,
        name,
        allowOnlyIntegers = false,
        minValue,
        maxValue,
        decimalScale,
        allowNegative = false,
        maxLength,
        ...other
    } = props;



    return (
        <NumericFormat
            {...other}
            getInputRef={ref}
            thousandSeparator={true}
            valueIsNumericString
            decimalScale={allowOnlyIntegers ? 0 : decimalScale ? decimalScale : 4}
            fixedDecimalScale={!allowOnlyIntegers}
            allowNegative={allowNegative}
            style={{
                paddingTop: '10px',
                paddingBottom: '10px',
            }}
            isAllowed={(values) => {
                const { floatValue, formattedValue, value } = values;

                if (formattedValue === '' || formattedValue === '-' || formattedValue === '.') {
                    return true;
                }

                if (floatValue === undefined) {
                    return true;
                }

                if (minValue !== undefined && floatValue < minValue) {
                    return false;
                }

                if (maxValue !== undefined && floatValue > maxValue) {
                    return false;
                }

                if (maxLength !== undefined && value && value.length > maxLength) {
                    return false;
                }

                return true;
            }}
            onValueChange={(values) => {
                onChange?.({
                    target: {
                        name: name as string,
                        value: values.floatValue ?? values.value ?? '',
                    },
                });
            }}
        />
    );
});